import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputError = _resolveComponent("FormInputError")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.groupClass),
    ref: "fieldGroup"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_FormInputError, {
      errors: _ctx.fieldErrors,
      "custom-errors": _ctx.customErrors,
      "prevent-wrap": _ctx.preventErrorWrap
    }, null, 8, ["errors", "custom-errors", "prevent-wrap"])
  ], 2))
}